import React from "react";
import PropTypes from 'prop-types';

export const Tooltip = React.forwardRef(({ data, type, style, className, richText }, ref) => {
    return (
        <div className={`${className} tooltip-wrapper ${type}-tooltip `} style={style} ref={ref}>
            {richText
                ?
                data
                :
                <span id="tooltip" className="body-text body-text-2 normal-font">{data}</span>
            }

        </div>
    );
});

Tooltip.propTypes = {
    data: PropTypes.any,
    type: PropTypes.string,

};
Tooltip.defaultProps = {
    data: "",
    type: "bottom",

};